import Vue from 'vue';
import AnimatedComponent from '../../components/Animated';

let els;

if ((els = document.querySelectorAll('.family-experience')).length > 0) {
    for (let i = 0; i < els.length; i++) {
        const el = els[i];

        new Vue({
            el,
            name: 'FamilyExperience',
            components: { AnimatedComponent },
            data() {
                return {
                    cities: [],
                    opened: false,
                    video: {
                        played: false
                    }
                };
            },
            computed: {

            },
            methods: {
                playVideo() {
                    this.video.played = true;
                    this.$refs.player.play();
                },
                stopVideo() {
                    this.video.played = true;
                    this.$refs.player.pause();
                },
                playerPlayed() {
                    this.video.played = true;
                },
                playerPaused() {
                    this.video.played = false;
                }
            },
            beforeMount() {

            }
        });
    }
}
